// extracted by mini-css-extract-plugin
module.exports = {"detail":"OperationDetailsPopupContent_detail__2OGzI"};